export const STATUS_CODES = {
  NO_PERMISSION: 403,
}
